import axios from 'axios'
import _get from 'lodash/get'
import store from './index'

const basePath = (process.env.NODE_ENV === 'development')? 'http://localhost:8080': ''

const instance = axios.create({
  baseURL: basePath + process.env.BASE_URL + 'api',
  timeout: 30000,
});

instance.interceptors.response.use(function (response) {
  const headers = response.headers
  if (headers['content-disposition'] && (headers['content-disposition']).indexOf('attachment;') > -1) {
    const type = headers['content-type']
    const blob = new Blob([response.data], { type: type })
    const link = document.createElement('a')
    const regex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/gi
    const filename = _get(regex.exec(headers['content-disposition']), '[1]', '')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    return link.click()
  }
  return _get(response, 'data', null)
}, function (error) {
  if (error.response.status === 403) {
    store.dispatch('logout')
  }
  return Promise.reject(error)
})

export default instance